module.exports = __webpack_public_path__ + "static/csi_dataviz3-ccbaa419393b12fc5a0fbf11a15c48b0.png";